export type Status = 'locked' | 'unlocked';
export type LocationType = 'sales' | 'production';
export type EditStatus = 'reported' | 'partial' | 'none';

//Orderbook
export type OrderStatus = 'processing' | 'completed';
export type PaidStatus = 'paid' | 'notPaid';
export type DeliveryType = '' | 'pickup' | 'delivery';
export type FormFieldName = 'customerName' | 'phone' | 'pickupTime' | 'receiverName';
export type SwitchStateKey = 'isPayed' | 'isDelivered';
export type FormErrors = {
	'lineItems'?: string;
	'customerName'?: string;
	'receiverName'?: string;
	'deliveryType'?: string;
	'pickupTime'?: string;
}

export const WeekHeaders = [
	'Mandag',
	'Tirsdag',
	'Onsdag',
	'Torsdag',
	'Fredag',
	'Lørdag',
	'Søndag',
];
export type Location = {
	title: string;
	locationType: LocationType;
	products?: Product[];
	id: number;
};

export type ProductCategory = {
	id: number;
	title: string;
};

export type Product = {
	id: number;
	productCategory: ProductCategory[];
	title: string;
	isBakeoff: boolean;
	amountPerParcel: number | null;
};

export type ProductEntry = {
	id: number;
	uid: string;
	status: Status;
	ordered: number;
	sold: number;
	remaining: number | null;
	waste: number;
	locationId: number;
	productId: number;
	date: Date;
	isReported: boolean;
	templateValue: number;
};

export type UserData = {
	uid: string;
	fullName: string;
};

export type Template = {
	uid: string;
	templateValues: TemplateEntry[];
	locationId: number;
};

export type TemplateEntry = {
	weekDay: number;
	value: number;
	productId: number;
};

export type ProductionData = {
	locations: Array<{
		locationId: string;
		locationName: string;
	}>;
	categories: Array<{
		categoryId: string;
		categoryName: string;
		products: Array<{
			productId: string;
			productName: string;
			entries: Array<{
				entryId: string;
				entryDate: string;
				amount: number;
				isBakeoff: boolean;
				locationId: string;
			}>;
		}>;
	}>;
};

export type StoreOrder = {
	id?: number;
	orderNumber?: string;
  statusColor?: string;
	statusText?: string;
	status: boolean;
	packedStatus: boolean;
  paidStatusColor?: string;
	paidStatusText?: string;
	paidStatus: boolean;
	pickupTime: string;
	deliveryType: string;
	customerName: string;
	attention: string;
	phone: string;
	receiverName: string;
	locationId: number;
	lineItems: LineItem[];
	dateCreated?: string;
	dateUpdated?: boolean;
	dateCancelled?: boolean;
};

export type LineItem = {
	id: number | string;
	orderId: number;
	description: string;
	qty: number;
	planning: number;
	plannedInPastry: number;
	plannedInBakery: number;
	approved: number;
  preparedBakery: number;
  preparedPastry: number;
};

export type Tab = {
	key: number;
	title: string;
};
